import { Navigate } from "react-router-dom"
import { isAuthenticated } from "../helpers/helpers"

export const PrivateRoute = ({ children }) => {
    return isAuthenticated() ? children : <Navigate to={'/login'} state={{ from: window.location.pathname }} />;
}
